<div class="process-info">
  {{ processInfo }}
</div>
<p><ngb-progressbar [type]="type" [value]="100" [striped]="true" [animated]="true"></ngb-progressbar></p>
